<template>
  <div id="app">

    <Navigation v-if="isLoggedIn"></Navigation>
    <router-view/>
    <Footer v-if="isLoggedIn"></Footer>
  </div>
</template>

<script>

  import Navigation from './components/Navigation.vue'
  import Footer from './components/Footer.vue'


  import './assets/styles/style.css'
  import './assets/styles/framework.css'
  
export default {
    components: { Navigation,Footer },
    computed : {
      isLoggedIn : function(){ return this.$store.getters.isLoggedIn}
    },

created: function () {
      this.$http.interceptors.response.use(undefined, function (err) {
        return new Promise(function (resolve, reject) {
          if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
            this.$store.dispatch(logout)
          }
          throw err;
        });
      });
    }
  }
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
  cursor: pointer;
}

#nav a:hover {
  text-decoration: underline;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
